import ScreenHeaderButton from 'common/components/screenHeader/ScreenHeaderButton';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ScreenTitle from '../../common/components/screenTitle/ScreenTitle';
import styles from './VehiclesManagementScreen.module.scss';
import MoneyFormat from 'common/components/moneyFormat/MoneyFormat';
import { DATE_FORMAT_DEFAUT, DATE_FORMAT_MONTH_YEAR, DefaultAssetImage, DEFAULT_PAGINATION_ITEMS_PER_PAGE, MAX_PAGINATION_ITEMS_PER_PAGE, LOGGER_LOG_TYPE, SEGMENT_FEATURES } from 'Config';
import FiltersIcon from 'assets/svg/desktop_filtres.svg';
import CarIcon from 'assets/svg/car.svg';
import CoinsIcon from 'assets/svg/coins.svg';
import CoinsBlackIcon from 'assets/svg/coins_black.svg';
import MediaIcon from 'assets/svg/media.svg';
import MediaIcon2 from 'assets/svg/Grupo_352.svg';
import ConeBlackIcon from 'assets/svg/cone_black.svg';
import GaugeIcon from 'assets/svg/gauge.svg';
import EuroIcon from 'assets/svg/euro.svg';
import TicketIcon from 'assets/svg/ticket.svg';
import FloorBrushIcon from 'assets/svg/floor-brush.svg';
import { useHistory } from 'react-router-dom';
import Logger from 'common/services/Logger';
import { useToasts } from 'react-toast-notifications';
import VehiclesService from 'api/vehicles/VehiclesService';
import { VehicleViewModel } from 'api/vehicles/models/VehicleViewModel';
import Popover from 'common/components/popover/Popover';
import VehiclesManagementFiltersScreen, { Filters } from './components/VehiclesManagementFiltersScreen';
import { VehiclesSearchCriteria } from 'api/vehicles/models/VehiclesSearchCriteria';
import { UserProfile } from 'api/account/models/UserProfile';
import UsersService from 'api/users/UsersService';
import { useSelector } from 'react-redux';
import { Reducers } from 'store/types';
import { VehicleCounterListDto } from 'api/vehicles/models/VehicleDto';
import DateFormat from 'common/components/dateFormat/dateFormat';
import IconWithText from 'common/components/iconWithText/IconWithText';
import FilterBadgesOverflow, { FilterBadgeItem } from 'common/components/filterBadgesOverflow/FilterBadgesOverflow';
import { CompactPageLayout, compactPageLayoutStyles } from 'common/components/compactPageLayout';
import InfoCard from 'common/components/infoCard/InfoCard';
import DataTableWithSidebar from 'common/components/dataTable/DataTableWithSidebar';
import { DataTableColumn, OrderData } from 'common/components/dataTable/models';
import useBidirectionalScroll from 'common/hooks/useBidirectionalScroll';
import ReactTooltip from 'react-tooltip';
import { BiTargetLock } from 'react-icons/bi';
import { FaFileExport } from 'react-icons/fa';
import dayjs from 'dayjs';
import colors from 'styles/export/colors.module.scss';
import Loading from 'common/services/Loading';
import LoadingSpinner from 'common/components/loading/LoadingSpinner';
import moment from 'moment';
import { ContractStatusColorEnum } from 'api/contracts/enums/ContractStatusColorEnum';
import Badge from 'common/components/badge/Badge';
import VatNotice from 'common/components/vatNotice/VatNotice';

import DropdownItem from 'common/components/popover/PopoverItem';
import Dropdown from 'common/components/dropdown/Dropdown';
import ReportColumnFilterModal from './components/ReportColumnFilterModal';

const defaultcostsEndDate = dayjs().endOf('month').toDate();
const FILTERS_CACHE_KEY = 'VEHICLESMANAGEMENTFILTER';

const INFO_CARD_COLORS = [
    colors.counterTeal1,
    colors.counterTeal2,
    colors.counterBlue1,
    colors.counterBlue2,
];

const VehiclesManagementScreen = () => {

    const { t } = useTranslation();
    const { addToast } = useToasts();

    const [vehicles, setVehicles] = useState<VehicleViewModel[]>([]);
    const history = useHistory();
    const [totalItems, setTotalItems] = useState(0);
    const [isLoadingMore, setIsLoadingMore] = useState(false);

    const [filters, setFilters] = useState<Filters>({
        //costsEndDate: defaultcostsEndDate, inactives: true 
    });
    const [filtersTotal, setFiltersTotal] = useState(0);

    const [counters, setCounters] = useState<VehicleCounterListDto>();

    const imageCacheKey = useRef(new Date().getTime());

    const userProfile = useSelector<Reducers, UserProfile | null>(state => state.authentication.profile);
    const hasCountersPolicy = UsersService.hasPolicies(userProfile?.policies || [], ['CHARGES_TOTAL_READ']);
    const hasGpsKmsReadPolicy = UsersService.hasPolicies(userProfile?.policies || [], ['SETTINGUP_GPS_KMS_READ']);
    const hasExportPolicy = UsersService.hasPolicies(userProfile?.policies || [], ['SETTINGUP_EXPORT_EXPENSES_WRITE']);
    const hasExportListingPolicy = UsersService.hasPolicies(userProfile?.policies || [], ['SETTINGUP_EXPORT_LISTING_WRITE']);

    // Bidirectional scroll hook
    const bidirectionalScroll = useBidirectionalScroll({
        cacheKey: FILTERS_CACHE_KEY,
        itemsPerPage: DEFAULT_PAGINATION_ITEMS_PER_PAGE,
    });

    const {
        loadedPageRange,
        isLoadingPrevious,
        scrollToRowId: scrollToItemId,
        shouldLoadAdjacentPages,
        setLoadedPageRange,
        setIsLoadingPrevious,
        resetScrollState,
        calculatePageFromIndex,
        prepareLoadPrevious,
        adjustScrollAfterPrepend,
        finishRestoration,
        initiateRestoration,
        getHasMore,
        getHasMorePrevious,
        getOnLoadMore,
        getOnLoadPrevious,
    } = bidirectionalScroll;

    const exportListingRef = useRef<{ exportExcel: () => Promise<void> } | null>(null);
    const countersLoaded = useRef<boolean>(false);
    const previousCriteria = useRef<VehiclesSearchCriteria | null>(null);
    const isLoadingData = useRef<boolean>(false);

    const [criteria, setCriteria] = useState<VehiclesSearchCriteria>({
        itemsPerPage: DEFAULT_PAGINATION_ITEMS_PER_PAGE,
        page: 1,
        orderColumn: 'v.registration_number',
        orderBy: 'asc',
        hasKmFeature: false,

        //costsEndDate: defaultcostsEndDate,
        //inactives: true
    });

    const isFirstLoad = useRef(true);

    const [pageLoaded, setPageLoaded] = useState(false);

    const [showReportColumnFilterModal, setShowReportColumnFilterModal] = useState<boolean>(false);
    const [reportType, setReportType] = useState<string>('');

    const [reRenderSearch, setReRenderSearch] = useState<number>(0);

    const getData = async (isLoadMore = false, shouldUpdateCounters = false) => {
        // Prevent concurrent API calls
        if (isLoadingData.current) {
            return;
        }
        isLoadingData.current = true;

        try {
            if (!isLoadMore) {
                Loading.show();
            } else {
                setIsLoadingMore(true);
            }

            saveOrdernationFilters();

            let countersDB = null;
            if (shouldUpdateCounters && hasCountersPolicy) {
                countersDB = await VehiclesService.getCountersList(criteria);
            }

            const vehiclesDB = await VehiclesService.getList(criteria);
            setTotalItems(vehiclesDB.totalItems);

            if (isLoadMore) {
                setVehicles(prev => [...prev, ...vehiclesDB.items]);
                setLoadedPageRange(prev => ({ ...prev, max: criteria.page }));
            } else {
                setVehicles(vehiclesDB.items);
            }

            if (countersDB) {
                setCounters(countersDB);
                countersLoaded.current = true;
            }

            // Defer tooltip rebuild to after render cycle
            setTimeout(() => ReactTooltip.rebuild(), 0);

            // Handle scroll restoration
            if (shouldLoadAdjacentPages.current) {
                shouldLoadAdjacentPages.current = false;
                const currentPage = criteria.page;
                const totalPages = Math.ceil(vehiclesDB.totalItems / (criteria.itemsPerPage || DEFAULT_PAGINATION_ITEMS_PER_PAGE));

                // Load previous page if exists
                if (currentPage > 1) {
                    try {
                        const prevCriteria = { ...criteria, page: currentPage - 1 };
                        const prevResult = await VehiclesService.getList(prevCriteria);
                        setVehicles(prev => [...prevResult.items, ...prev]);
                        setLoadedPageRange(prev => ({ ...prev, min: currentPage - 1 }));
                    } catch (e) {
                        Logger.error(LOGGER_LOG_TYPE.VEHICLES, `Couldn't load previous page`, e);
                    }
                }

                // Load next page if exists
                if (currentPage < totalPages) {
                    try {
                        const nextCriteria = { ...criteria, page: currentPage + 1 };
                        const nextResult = await VehiclesService.getList(nextCriteria);
                        setVehicles(prev => [...prev, ...nextResult.items]);
                        setLoadedPageRange(prev => ({ ...prev, max: currentPage + 1 }));
                    } catch (e) {
                        Logger.error(LOGGER_LOG_TYPE.VEHICLES, `Couldn't load next page`, e);
                    }
                }

                finishRestoration();
            }
        } catch (error) {
            Logger.error(LOGGER_LOG_TYPE.VEHICLES, `Couldn't get vehicles list`, error);
            addToast(t('common.messages.error_load_info'), { appearance: 'error' });
            resetScrollState();
        } finally {
            isLoadingData.current = false;
            setIsLoadingMore(false);
            if (!isLoadMore) {
                setPageLoaded(true);
            }
            // Defer hiding the loading overlay so React has time to commit the heavy
            // DataTable render and the browser to paint it before the spinner disappears.
            // Without this, on first load the spinner hides BEFORE the rows are painted,
            // leaving a blank white area while the render thread is busy.
            setTimeout(() => Loading.hide(), 0);
        }
    };

    // Handler for infinite scroll load more
    const loadMore = useCallback(() => {
        // Use ref for synchronous check to prevent multiple rapid calls
        if (isLoadingData.current || isLoadingMore || vehicles.length >= totalItems) return;
        const nextPage = loadedPageRange.max + 1;
        setCriteria(prev => ({ ...prev, page: nextPage }));
    }, [isLoadingMore, vehicles.length, totalItems, loadedPageRange.max]);

    // Load previous pages (bidirectional scroll)
    const loadPrevious = useCallback(async () => {
        if (isLoadingPrevious || loadedPageRange.min <= 1) return;

        setIsLoadingPrevious(true);
        const prevPage = loadedPageRange.min - 1;

        try {
            prepareLoadPrevious();
            const prevCriteria: VehiclesSearchCriteria = {
                ...criteria,
                page: prevPage,
                itemsPerPage: DEFAULT_PAGINATION_ITEMS_PER_PAGE,
            };
            const result = await VehiclesService.getList(prevCriteria);

            setVehicles(prev => [...result.items, ...prev]);
            setLoadedPageRange(prev => ({ ...prev, min: prevPage }));
        } catch (error) {
            Logger.error(LOGGER_LOG_TYPE.VEHICLES, `Couldn't get previous vehicles page`, error);
            addToast(t('common.messages.error_load_info'), { appearance: 'error' });
        } finally {
            setIsLoadingPrevious(false);
        }
    }, [isLoadingPrevious, loadedPageRange.min, criteria, addToast, t]);

    // Adjust scroll position after prepending items
    useEffect(() => {
        if (!isLoadingPrevious) {
            adjustScrollAfterPrepend();
        }
    }, [vehicles, isLoadingPrevious, adjustScrollAfterPrepend]);

    // Order state for DataTable
    const [order, setOrder] = useState<OrderData<VehicleViewModel>>({
        field: 'registrationNumber',
        orderColumn: 'v.registration_number',
        isOrderAsc: true,
    });

    const getFieldFromOrderColumn = (oc: string): keyof VehicleViewModel => {
        const mapping: Record<string, string> = {
            'v.registration_number': 'registrationNumber',
            'v.active': 'active',
            'vb.name': 'vehicleBrandName',
            'vm.name': 'vehicleModelName',
            'use_contract_info.name': 'useContractTypeName',
            'use_contract_info.end_date': 'useContractEndDate',
            'use_contract_info.past_months': 'useContractPastMonths',
            'v.current_kilometers': 'currentKilometers',
            'v.current_kilometers_tracking': 'currentKilometersTracking',
            'v.average_target_month': 'averageTargetMonth',
            'monthly_cost_total_kilometers': 'pricePerKm',
            'monthly_cost_average': 'monthlyCostAverage',
            'monthly_costs.total': 'monthlyCostTotal',
            'total_fines': 'totalFines',
            'total_cleaning': 'totalCleaning',
            'total_accidents': 'totalAccidents',
        };
        return (mapping[oc] ?? 'registrationNumber') as keyof VehicleViewModel;
    };

    // Handler de ordenação
    const handleOrderChange = (orderData: OrderData<VehicleViewModel>) => {
        setOrder(orderData);
        setVehicles([]);
        resetScrollState();
        setTotalItems(0); // Prevent loadMore from triggering before new data loads
        setCriteria(prev => ({
            ...prev,
            page: 1,
            orderBy: orderData.isOrderAsc ? 'asc' : 'desc',
            orderColumn: orderData.orderColumn || orderData.field as string,
        }));
    };

    const renderImageCell = (row: VehicleViewModel) => {
        return (
            <div className={styles.imageDescCell}>
                <div className={styles.contentImage} style={{ width: '5rem', height: '3rem' }}>
                    <div className={styles.img} style={{ width: '5rem', height: '3rem', backgroundImage: row?.photoUrl ? 'url(' + row?.photoUrl + '?_=' + imageCacheKey.current + ')' : row?.vehicleSegmentDefaultPhotoUrl ? 'url(' + row?.vehicleSegmentDefaultPhotoUrl + '?_=' + imageCacheKey.current + ')' : 'url(' + DefaultAssetImage + ')' }} />
                </div>
            </div>
        )
    }

    const renderDescCell = (row: VehicleViewModel) => {
        return (
            <div className={styles.descCell}>
                <div className={styles.columnPlate}>
                    {row.registrationNumber}
                </div>
                <div className={styles.columnBrand}>{(row.vehicleBrandName ?? '') + (row.vehicleBrandName && row.vehicleModelName ? ' | ' : '') + (row.vehicleModelName ?? '')}</div>
                {/*<div className={styles.columnSpec}>{row.vehicleSegmentName + (' | ') + (t(('vehicle.fuels.' + row.fuelName) as any))}</div>*/}
            </div>
        )
    }

    const showField = (feature: string, segmentFeatures: string[]) => {
        return (segmentFeatures?.findIndex(x => x == feature) ?? -1) >= 0;
    }

    const tableColumns: DataTableColumn<VehicleViewModel>[] = useMemo(() => [
        // Imagem
        {
            field: 'photoUrl' as keyof VehicleViewModel,
            name: t('common.image') as string,
            hideOrderButton: true,
            width: 90,
            excludeFromExport: true,
            renderCell: renderImageCell,
        },
        // Ativo (matrícula)
        {
            field: 'registrationNumber' as keyof VehicleViewModel,
            name: t('vehicles.list.vehicle') as string,
            orderColumn: 'v.registration_number',
            width: 130,
            renderCell: row => (
                <div className={styles.descCell}>
                    <div className={styles.columnPlate}>
                        {row.registrationNumber}
                    </div>
                </div>
            ),
        },
        // Estado do Ativo
        {
            field: 'active' as keyof VehicleViewModel,
            name: t('vehicles_management.list.asset_status') as string,
            orderColumn: 'v.active',
            width: 100,
            exportValue: row => row.active
                ? t('vehicles_management.list.asset_active') as string
                : t('vehicles_management.list.asset_inactive') as string,
            renderCell: row => (
                <Badge backgroundColor={row.active ? '#56CF76' : '#DC4C4C'}>
                    {row.active
                        ? t('vehicles_management.list.asset_active')
                        : t('vehicles_management.list.asset_inactive')}
                </Badge>
            ),
        },
        // Marca
        {
            field: 'vehicleBrandName' as keyof VehicleViewModel,
            name: t('vehicle.brand') as string,
            orderColumn: 'vb.name',
            width: 100,
            renderCell: row => <>{row.vehicleBrandName || '-'}</>,
        },
        // Modelo
        {
            field: 'vehicleModelName' as keyof VehicleViewModel,
            name: t('vehicle.model') as string,
            orderColumn: 'vm.name',
            width: 100,
            renderCell: row => <>{row.vehicleModelName || '-'}</>,
        },
        // Segmento
        {
            field: 'vehicleSegmentName' as keyof VehicleViewModel,
            name: t('vehicle.type') as string,
            orderColumn: 'vs.name',
            width: 130,
            renderCell: row => <>{row.vehicleSegmentName || '-'}</>,
        },
        // Agência
        {
            field: 'vehicleLocals' as keyof VehicleViewModel,
            name: t('vehicle.local') as string,
            hideOrderButton: true,
            width: 130,
            exportValue: row => (row.vehicleLocals ?? []).map(l => l.localName).join(', ') || '-',
            renderCell: row => <>{(row.vehicleLocals ?? []).map(l => l.localName).join(', ') || '-'}</>,
        },
        // Tipo Financiamento (apenas o tipo)
        {
            field: 'useContractTypeName' as keyof VehicleViewModel,
            name: t('common.type_funding') as string,
            orderColumn: 'use_contract_info.name',
            width: 100,
            exportValue: row => row.useContractTypeName
                ? t(`common.use_contract_types.${row.useContractTypeName}` as any) as string
                : '',
            renderCell: row => {
                if (!row.useContractTypeName) return <>-</>;
                const label = t(`common.use_contract_types.${row.useContractTypeName}` as any);
                // Para PURCHASE, mostra tooltip com data da compra
                if (row.useContractTypeName === 'PURCHASE' && row.useContractStartDate) {
                    const formattedDate = dayjs(row.useContractStartDate).format(DATE_FORMAT_DEFAUT);
                    return (
                        <span
                            data-tip={t('vehicles_management.list.purchase_date', { date: formattedDate })}
                            style={{ cursor: 'pointer' }}
                        >
                            {label}
                        </span>
                    );
                }
                return <>{label}</>;
            },
        },
        // Estado do Contrato
        {
            field: 'useContractEndDate' as keyof VehicleViewModel,
            name: t('vehicles_management.list.contract_status') as string,
            orderColumn: 'use_contract_info.end_date',
            width: 100,
            exportValue: row => {
                if (row.useContractTypeName === 'PURCHASE') return '-';
                const isExpired = !row.useContractTypeName && row.useContractExpiredEndDate;
                const hasContract = row.useContractTypeName || row.useContractExpiredEndDate;
                if (!hasContract) return '-';
                return isExpired
                    ? t('vehicles_management.list.contract_expired') as string
                    : t('vehicles_management.list.contract_active') as string;
            },
            renderCell: row => {
                // "Compra" (PURCHASE) não tem contrato com prazo
                if (row.useContractTypeName === 'PURCHASE') return <>-</>;
                const isExpired = !row.useContractTypeName && row.useContractExpiredEndDate;
                const hasContract = row.useContractTypeName || row.useContractExpiredEndDate;
                if (!hasContract) return <>-</>;
                return (
                    <span style={{ color: isExpired ? ContractStatusColorEnum.EXPIRED : 'inherit' }}>
                        {isExpired
                            ? t('vehicles_management.list.contract_expired')
                            : t('vehicles_management.list.contract_active')}
                    </span>
                );
            },
        },
        // Data de Expiração do Contrato
        {
            field: 'useContractExpiredEndDate' as keyof VehicleViewModel,
            name: t('vehicles_management.list.contract_expiration_date') as string,
            orderColumn: 'use_contract_info.end_date',
            width: 120,
            exportValue: row => {
                if (row.useContractTypeName === 'PURCHASE') return '-';
                const expirationDate = row.useContractEndDate || row.useContractExpiredEndDate;
                if (!expirationDate) return '-';
                return dayjs(expirationDate).format(DATE_FORMAT_DEFAUT);
            },
            renderCell: row => {
                // "Compra" (PURCHASE) não tem data de expiração
                if (row.useContractTypeName === 'PURCHASE') return <>-</>;
                const isExpired = !row.useContractTypeName && row.useContractExpiredEndDate;
                const expirationDate = row.useContractEndDate || row.useContractExpiredEndDate;
                if (!expirationDate) return <>-</>;
                return (
                    <span style={{ color: isExpired ? ContractStatusColorEnum.EXPIRED : 'inherit' }}>
                        <DateFormat value={expirationDate} format={DATE_FORMAT_DEFAUT} />
                    </span>
                );
            },
        },
        // Progresso (meses)
        {
            field: 'useContractPastMonths' as keyof VehicleViewModel,
            name: t('vehicles_management.list.progress_months') as string,
            orderColumn: 'use_contract_info.past_months',
            width: 110,
            exportValue: row => {
                if (!row.useContractMonthsContract || !row.useContractPastMonths) return '';
                return `${row.useContractPastMonths} / ${row.useContractMonthsContract}`;
            },
            renderCell: row => {
                if (!row.useContractMonthsContract || !row.useContractPastMonths) return <>-</>;
                const percentage = ((row.useContractPastMonths / row.useContractMonthsContract) * 100).toFixed(1);
                return (
                    <span
                        data-tip={t('vehicles_management.list.progress_percentage', { percentage })}
                        style={{ cursor: 'pointer' }}
                    >
                        {`${row.useContractPastMonths} ${t('vehicles_management.list.of')} ${row.useContractMonthsContract}`}
                    </span>
                );
            },
        },
        // === QUILÓMETROS (3 colunas separadas) ===
        // Kms Atuais
        {
            field: 'currentKilometers' as keyof VehicleViewModel,
            name: t('vehicles_management.list.current_kilometers') as string,
            orderColumn: 'v.current_kilometers',
            width: 120,
            headerNote: `${t('common.unit')}: ${t('vehicles_management.list.kilometers_minified')}`,
            exportValue: row => showField(SEGMENT_FEATURES.KM, row.segmentFeatures ?? []) && row.currentKilometers
                ? row.currentKilometers
                : '',
            renderCell: row => (
                <IconWithText
                    icon={GaugeIcon}
                    value={showField(SEGMENT_FEATURES.KM, row.segmentFeatures ?? []) ? row.currentKilometers : '-'}
                    suffix={t('vehicles_management.list.kilometers_minified')}
                    isNumeric={true}
                />
            ),
        },
        // Kms Reais (GPS)
        {
            field: 'currentKilometersTracking' as keyof VehicleViewModel,
            name: t('vehicles_management.list.kms_gps') as string,
            orderColumn: 'v.current_kilometers_tracking',
            width: 120,
            headerNote: `${t('common.unit')}: Km`,
            exportValue: row => hasGpsKmsReadPolicy && row.currentKilometersTracking
                ? row.currentKilometersTracking
                : '',
            renderCell: row => (
                <>
                    {hasGpsKmsReadPolicy && row.currentKilometersTracking
                        ? <MoneyFormat value={row.currentKilometersTracking} suffix={' Km'} fixedDecimalScale={false} />
                        : '-'}
                </>
            ),
        },
        // Objetivo Médio
        {
            field: 'averageTargetMonth' as keyof VehicleViewModel,
            name: t('vehicles_management.list.average_target_month') as string,
            orderColumn: 'v.average_target_month',
            width: 140,
            headerNote: `${t('common.unit')}: ${t('vehicles_management.list.kilometers_minified')}`,
            exportValue: row => row.averageTargetMonth ?? '',
            renderCell: row => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
                    <BiTargetLock />
                    {row.averageTargetMonth
                        ? <MoneyFormat value={row.averageTargetMonth} suffix={t('vehicles_management.list.kilometers_minified')} />
                        : '-'}
                </div>
            ),
        },
        // === CUSTOS (3 colunas separadas) ===
        // Preço por Km
        {
            field: 'pricePerKm' as keyof VehicleViewModel,
            name: t('vehicles_management.list.price_per_km') as string,
            orderColumn: 'monthly_cost_total_kilometers',
            width: 110,
            headerNote: `${t('common.unit')}: ${t('common.euro')}`,
            exportValue: row => {
                return row?.monthlyCostTotal && row?.monthlyCostTotal > 0 && row.currentKilometers && row.currentKilometers > 0
                    ? Math.round((row.monthlyCostTotal / row.currentKilometers) * 100) / 100
                    : 0;
            },
            renderCell: row => (
                <IconWithText
                    icon={EuroIcon}
                    value={(row?.monthlyCostTotal && row?.monthlyCostTotal > 0 && row.currentKilometers && row.currentKilometers > 0
                        ? (row.monthlyCostTotal / row.currentKilometers)
                        : 0)}
                    fixedDecimalScale={true}
                    suffix={t('common.euro')}
                />
            ),
        },
        // Custo Médio
        {
            field: 'monthlyCostAverage' as keyof VehicleViewModel,
            name: t('vehicles_management.list.average_monthly_cost') as string,
            orderColumn: 'monthly_cost_average',
            width: 140,
            headerNote: `${t('common.unit')}: ${t('vehicles_management.list.euro_months')}`,
            exportValue: row => row.monthlyCostAverage ?? '',
            renderCell: row => (
                <IconWithText
                    icon={MediaIcon2}
                    value={row.monthlyCostAverage}
                    size={'sm'}
                    fixedDecimalScale={true}
                    suffix={t('vehicles_management.list.euro_months')}
                />
            ),
        },
        // Custo Acumulado
        {
            field: 'monthlyCostTotal' as keyof VehicleViewModel,
            name: t('vehicles_management.list.total_monthly_cost') as string,
            orderColumn: 'monthly_costs.total',
            width: 140,
            headerNote: `${t('common.unit')}: ${t('common.euro')}`,
            exportValue: row => row.monthlyCostTotal ?? '',
            renderCell: row => (
                <IconWithText
                    icon={CoinsBlackIcon}
                    value={row.monthlyCostTotal}
                    size={'sm'}
                    fixedDecimalScale={true}
                    suffix={t('common.euro')}
                />
            ),
        },
        // Multas
        {
            field: 'totalFines' as keyof VehicleViewModel,
            name: t('vehicles_management.list.fines_column') as string,
            orderColumn: 'total_fines',
            width: 100,
            headerNote: `${t('common.unit')}: ${t('common.euro')}`,
            renderCell: row => (
                <IconWithText
                    icon={TicketIcon}
                    value={row.totalFines ?? 0}
                    size={'sm'}
                    fixedDecimalScale={true}
                    suffix={' ' + t('common.euro')}
                />
            ),
        },
        // Limpezas
        {
            field: 'totalCleaning' as keyof VehicleViewModel,
            name: t('vehicles_management.list.cleaning_column') as string,
            orderColumn: 'total_cleaning',
            width: 90,
            renderCell: row => (
                <IconWithText
                    icon={FloorBrushIcon}
                    value={row.totalCleaning ?? 0}
                    size={'sm'}
                />
            ),
        },
        // Acidentes
        {
            field: 'totalAccidents' as keyof VehicleViewModel,
            name: t('vehicles_management.list.accidents_column') as string,
            orderColumn: 'total_accidents',
            width: 90,
            renderCell: row => (
                <IconWithText
                    icon={ConeBlackIcon}
                    value={row.totalAccidents ?? 0}
                    size={'sm'}
                />
            ),
        },
    ], [t, hasGpsKmsReadPolicy]);

    const navigateTo = (type?: string, id?: string) => {
        if (id) {
            history.push(`/vehicles/${type}/${id}/informations/list/undefined/undefined/undefined/undefined/${'vehicles-management'}`);
        } else {
            history.push(`/vehicles/${type}`);
        }
    }

    const onRowClick = (row: VehicleViewModel, index: number, event: any) => {
        if (row.id) {
            event.preventDefault();
            event.stopPropagation();

            // Calculate the actual page of the clicked item based on its position in the list
            const actualPage = calculatePageFromIndex(index);

            // Save scroll position with actual page and item id
            const newFilters = { ...filters };
            newFilters.page = actualPage;
            newFilters.scrollToItemId = row.id;
            newFilters.orderBy = criteria.orderBy;
            newFilters.orderColumn = criteria.orderColumn;
            saveFiltersOnCache(newFilters);

            if (event.ctrlKey) {
                window.open('vehicles/details/' + row.id, '_blank');
                return;
            }
            navigateTo('details', row.id);
        }
    };

    const saveOrdernationFilters = () => {
        const newFilters = { ...filters };
        newFilters.orderBy = criteria.orderBy;
        newFilters.orderColumn = criteria.orderColumn;
        saveFiltersOnCache(newFilters);
    };

    const saveFiltersOnCache = (f: Filters) => {
        // Replace filters completely instead of merging to ensure cleared values take effect
        setFilters(f);
        // Keep page and scrollToItemId when saving scroll position
        if (f.scrollToItemId && f.page) {
            localStorage.setItem(FILTERS_CACHE_KEY, JSON.stringify(f));
        } else {
            const { page, scrollToItemId, ...filtersWithoutScrollData } = f as Filters & { scrollToItemId?: string };
            localStorage.setItem(FILTERS_CACHE_KEY, JSON.stringify(filtersWithoutScrollData));
        }
    };

    useEffect(() => {
        if (isFirstLoad.current === true) {
            // Ligar o overlay já no mount, antes de loadFilters + setCriteria + 2º useEffect
            // cycle — caso contrário a página fica visivelmente "congelada" (header + lista
            // vazia) até getData() correr o Loading.show(). O Loading.hide() no finally do
            // getData fecha o ciclo normalmente.
            Loading.show();
            loadFilters();
        } else {
            // Detect if it's a load more (page > max loaded page and items already exist)
            const isLoadMore = criteria.page > loadedPageRange.max && vehicles.length > 0;

            // Check if only order/page changed (not filters that affect counters)
            const prev = previousCriteria.current;
            const onlyOrderOrPageChanged = prev &&
                prev.registrationNumber === criteria.registrationNumber &&
                prev.segmentId === criteria.segmentId &&
                JSON.stringify(prev.localIds) === JSON.stringify(criteria.localIds) &&
                prev.localOperator === criteria.localOperator &&
                prev.minCost === criteria.minCost &&
                prev.maxCost === criteria.maxCost &&
                prev.minCostTotal === criteria.minCostTotal &&
                prev.maxCostTotal === criteria.maxCostTotal &&
                prev.costsStartDate === criteria.costsStartDate &&
                prev.costsEndDate === criteria.costsEndDate &&
                prev.useContractTypeId === criteria.useContractTypeId &&
                prev.useContractActive === criteria.useContractActive &&
                prev.useContractEndsBefore === criteria.useContractEndsBefore &&
                prev.useContractEndsAfter === criteria.useContractEndsAfter &&
                prev.inactives === criteria.inactives;

            // Always load counters on first data fetch, or when filters changed
            const shouldLoadCounters = !countersLoaded.current || !onlyOrderOrPageChanged;
            getData(isLoadMore, shouldLoadCounters);
            previousCriteria.current = { ...criteria };
        }
    }, [criteria]);

    const loadFilters = () => {
        // Set isFirstLoad to false BEFORE any setCriteria to avoid duplicate calls
        isFirstLoad.current = false;

        const cachedFilters = localStorage.getItem(FILTERS_CACHE_KEY);
        if (cachedFilters != null) {
            const f = JSON.parse(cachedFilters);

            // If returning to list with saved scroll position
            if (f.scrollToItemId) {
                // Use the hook to initiate restoration
                const startPage = initiateRestoration({
                    page: f.page || 1,
                    scrollToItemId: f.scrollToItemId,
                });

                // Clear scroll position from cache
                const cleanedFilters = { ...f, scrollToItemId: undefined, page: 1 };
                localStorage.setItem(FILTERS_CACHE_KEY, JSON.stringify(cleanedFilters));
                setFilters(cleanedFilters);
                updateTotalFilters(cleanedFilters);

                // Set criteria to start at the saved page
                setCriteria(prev => ({
                    ...prev,
                    registrationNumber: f.registrationNumber,
                    registrationDate: f.registrationDate,
                    segmentId: f.segmentId,
                    localIds: f.localIds,
                    localOperator: f.localOperator,
                    minCost: f.costAverage && f.costAverage[0],
                    maxCost: f.costAverage && f.costAverage[1],
                    minCostTotal: f.costAccumulated && f.costAccumulated[0],
                    maxCostTotal: f.costAccumulated && f.costAccumulated[1],
                    costsStartDate: f.costsStartDate,
                    costsEndDate: f.costsEndDate,
                    useContractTypeId: f.useContractTypeId,
                    useContractActive: f.useContractActive,
                    useContractEndsAfter: f.useContractEndsAfter,
                    useContractEndsBefore: f.useContractEndsBefore,
                    inactives: f.inactives,
                    orderBy: f.orderBy,
                    orderColumn: f.orderColumn,
                    page: startPage,
                    itemsPerPage: DEFAULT_PAGINATION_ITEMS_PER_PAGE,
                }));

                if (f.orderBy && f.orderColumn) {
                    setOrder({
                        field: getFieldFromOrderColumn(f.orderColumn),
                        orderColumn: f.orderColumn,
                        isOrderAsc: f.orderBy === 'asc',
                    });
                }

                return;
            }

            // Normal load without scroll restoration
            f.scrollToItemId = undefined;
            f.page = 1;
            resetScrollState();
            localStorage.setItem(FILTERS_CACHE_KEY, JSON.stringify(f));

            onChangeFilters(f, true);
        } else {
            const f = {
                costsEndDate: defaultcostsEndDate,
                inactives: true
            };

            onChangeFilters(f, true);
        }
    };

    const onChangeFilters = (f: Filters, isOnLoad?: boolean) => {
        updateTotalFilters(f);
        saveFiltersOnCache(f);

        // Reset items when filters change (for infinite scroll)
        if (!isOnLoad) {
            setVehicles([]);
            resetScrollState();
            setTotalItems(0);
        }

        const effectiveOrderColumn = f.orderColumn || 'v.registration_number';

        setCriteria(prev => ({
            ...prev,
            registrationNumber: f.registrationNumber,
            registrationDate: f.registrationDate,
            segmentId: f.segmentId,
            localIds: f.localIds,
            localOperator: f.localOperator,
            minCost: f.costAverage && f.costAverage[0],
            maxCost: f.costAverage && f.costAverage[1],
            minCostTotal: f.costAccumulated && f.costAccumulated[0],
            maxCostTotal: f.costAccumulated && f.costAccumulated[1],
            driverId: f.driverId,
            costsStartDate: f.costsStartDate,
            costsEndDate: f.costsEndDate,
            useContractTypeId: f.useContractTypeId,
            useContractActive: f.useContractActive,
            useContractEndsAfter: f.useContractEndsAfter,
            useContractEndsBefore: f.useContractEndsBefore,
            inactives: f.inactives,
            orderBy: f.orderBy || prev.orderBy || 'asc',
            orderColumn: f.orderColumn || prev.orderColumn || 'v.registration_number',
            page: 1,
        }));

        setOrder({
            field: getFieldFromOrderColumn(effectiveOrderColumn),
            orderColumn: effectiveOrderColumn,
            isOrderAsc: (f.orderBy || 'asc') === 'asc',
        });

        setReRenderSearch(r => r + 1);
    };

    const updateTotalFilters = (f: Filters) => {
        let total = 0;

        if (f.registrationNumber) {
            total++;
        }
        if (f.registrationDate) {
            total++;
        }
        if (f.segmentId && f.segmentId.length > 0) {
            total++;
        }
        if (f.costAverage && (f.costAverage[0] != undefined || f.costAverage[1] != undefined)) {
            total++;
        }
        if (f.costAccumulated && (f.costAccumulated[0] != undefined || f.costAccumulated[1] != undefined)) {
            total++;
        }
        if (f.costsStartDate || f.costsEndDate) {
            total++;
        }

        if (f.useContractTypeId) {
            total++;
        }

        if (f.useContractActive != undefined) {
            total++;
        }

        if (f.useContractEndsAfter || f.useContractEndsBefore) {
            total++;
        }

        if (f.localIds?.length) {
            total++;
        }

        if (f.inactives) {
            total++;
        }

        setFiltersTotal(total);
    }

    const renderCounterBoxes = () => {
        return (
            <div className={compactPageLayoutStyles.rowCounters}>
                {counters && (
                    <InfoCard
                        label={t('vehicles_management.list.number_vehicles') as string}
                        value={counters.numberVehicles ?? 0}
                        icon={CarIcon}
                        backgroundColor={INFO_CARD_COLORS[0]}
                    />
                )}
                {counters && (
                    <InfoCard
                        label={t('vehicles_management.list.average_cost') as string}
                        value={counters.costTotalMoyenne ?? 0}
                        icon={MediaIcon}
                        backgroundColor={INFO_CARD_COLORS[1]}
                        isMoney
                    />
                )}
                {counters && (
                    <InfoCard
                        label={t('vehicles_management.list.total_cost') as string}
                        value={counters.costTotalAccumulated ?? 0}
                        icon={CoinsIcon}
                        backgroundColor={INFO_CARD_COLORS[2]}
                        isMoney
                    />
                )}
                {counters && (
                    <div data-tip={t('vehicles_management.list.average_cost_per_km_tooltip', {
                        accumulated_cost: t('vehicles_management.list.total_monthly_cost'),
                        current_km: t('vehicles_management.list.current_kilometers'),
                        assets: t('vehicles_management.list.vehicles'),
                    }) as string}>
                        <InfoCard
                            label={t('vehicles_management.list.average_cost_per_km') as string}
                            value={counters.costPerKmAverage ?? 0}
                            icon={MediaIcon}
                            backgroundColor={INFO_CARD_COLORS[3]}
                            isMoney
                        />
                    </div>
                )}
            </div>
        );
    };

    // Build filter badge items for FilterBadgesOverflow
    const filterItems = useMemo<FilterBadgeItem[]>(() => {
        const items: FilterBadgeItem[] = [];

        // Datas de custo
        if (filters.costsStartDate || filters.costsEndDate) {
            const start = filters.costsStartDate ? dayjs(filters.costsStartDate).format(DATE_FORMAT_MONTH_YEAR) : '';
            const end = filters.costsEndDate ? dayjs(filters.costsEndDate).format(DATE_FORMAT_MONTH_YEAR) : '';
            items.push({
                key: 'costsDates',
                label: t('vehicles_management.list.total_monthly_cost_date') as string,
                value: start && end ? `${t('common.range.from')} ${start} ${t('common.range.to')} ${end}` : start || end,
                onRemove: () => onChangeFilters({ ...filters, costsStartDate: undefined, costsEndDate: undefined })
            });
        }

        // Matrícula
        if (filters.registrationNumber) {
            items.push({
                key: 'registrationNumber',
                label: t('vehicle.registration_identification') as string,
                value: filters.registrationNumber,
                onRemove: () => onChangeFilters({ ...filters, registrationNumber: undefined })
            });
        }

        // Segmento/Tipo
        if (filters.segmentName) {
            items.push({
                key: 'segment',
                label: t('vehicle.type') as string,
                value: filters.segmentName,
                onRemove: () => onChangeFilters({ ...filters, segmentId: undefined, segmentName: undefined })
            });
        }

        // Agência
        if (filters.localNames?.length) {
            items.push({
                key: 'local',
                label: `${t('vehicle.local')} (${filters.localOperator === 'AND' ? t('common.filter_all' as any) : t('common.filter_any' as any)})` as string,
                value: filters.localNames.join(', '),
                onRemove: () => onChangeFilters({ ...filters, localIds: [], localNames: [] })
            });
        }

        // Condutor
        if (filters.driverName) {
            items.push({
                key: 'driver',
                label: t('common.state') as string,
                value: filters.driverName,
                onRemove: () => onChangeFilters({ ...filters, driverId: undefined, driverName: undefined })
            });
        }

        // Custo médio
        if (filters.costAverage?.filter(x => x !== undefined).length) {
            let value = '';
            if (filters.costAverage.filter(i => i !== undefined).length === 2) {
                value = `${filters.costAverage[0]} - ${filters.costAverage[1]}`;
            } else if (filters.costAverage[0] !== undefined) {
                value = `> ${filters.costAverage[0]}`;
            } else {
                value = `< ${filters.costAverage[1]}`;
            }
            items.push({
                key: 'costAverage',
                label: t('vehicles_management.list.average_monthly_cost') as string,
                value,
                onRemove: () => onChangeFilters({ ...filters, costAverage: undefined })
            });
        }

        // Custo acumulado
        if (filters.costAccumulated?.filter(x => x !== undefined).length) {
            let value = '';
            if (filters.costAccumulated.filter(i => i !== undefined).length === 2) {
                value = `${filters.costAccumulated[0]} - ${filters.costAccumulated[1]}`;
            } else if (filters.costAccumulated[0] !== undefined) {
                value = `> ${filters.costAccumulated[0]}`;
            } else {
                value = `< ${filters.costAccumulated[1]}`;
            }
            items.push({
                key: 'costAccumulated',
                label: t('vehicles_management.list.total_monthly_cost') as string,
                value,
                onRemove: () => onChangeFilters({ ...filters, costAccumulated: undefined })
            });
        }

        // Tipo financiamento
        if (filters.useContractTypeName) {
            items.push({
                key: 'useContractType',
                label: t('common.type_funding') as string,
                value: filters.useContractTypeName,
                onRemove: () => onChangeFilters({ ...filters, useContractTypeId: undefined, useContractTypeName: undefined })
            });
        }

        // Estado contrato
        if (filters.useContractActive !== undefined) {
            items.push({
                key: 'useContractActive',
                label: t('common.state') as string,
                value: filters.useContractActive ? t('contracts.states.in_progress') as string : t('contracts.states.expired') as string,
                onRemove: () => onChangeFilters({ ...filters, useContractActive: undefined })
            });
        }

        // Datas expiração contrato
        if (filters.useContractEndsBefore || filters.useContractEndsAfter) {
            const start = filters.useContractEndsAfter ? dayjs(filters.useContractEndsAfter).format(DATE_FORMAT_DEFAUT) : '';
            const end = filters.useContractEndsBefore ? dayjs(filters.useContractEndsBefore).format(DATE_FORMAT_DEFAUT) : '';
            items.push({
                key: 'contractExpiration',
                label: t('contracts.use_contract.expiration_date') as string,
                value: start && end ? `${t('common.range.from')} ${start} ${t('common.range.to')} ${end}` : start || end,
                onRemove: () => onChangeFilters({ ...filters, useContractEndsBefore: undefined, useContractEndsAfter: undefined })
            });
        }

        // Inativos
        if (filters.inactives) {
            items.push({
                key: 'inactives',
                label: t('vehicle.inactives') as string,
                value: t('common.yes') as string,
                onRemove: () => onChangeFilters({ ...filters, inactives: false })
            });
        }

        return items;
    }, [filters, t]);

    const getReport = async (type: string) => {
        if (type === 'VEHICLE_EXPENSES_EXCEL') {
            await getExpensesReport(true);
        } else if (type === 'VEHICLE_EXPENSES_DETAILS_EXCEL') {
            await getExpensesReport(false);
        }
        else {
            await getVehiclesDetailsReport();
        }
    }

    const getExpensesReport = async (total: boolean) => {
        Loading.show();
        try {
            const report = total ? await VehiclesService.getExpensesTotalsReport(criteria) : await VehiclesService.getExpensesDetailsReport(criteria);
            const title = total ? t('vehicles_management.list.vehicles_expenses_excel_total_title') : t('vehicles_management.list.vehicles_expenses_excel_details_title');
            saveAs(report, `${title}_${moment(new Date()).format('YYYY_MM_DD_HH_mm_ss')}.xlsx`);
            Loading.hide();
        } catch (error) {
            Loading.hide();
            Logger.error(LOGGER_LOG_TYPE.VEHICLES, `Couldn't get vehicle expenses report`, error);
            addToast(t('common.messages.error_load_info'), { appearance: 'error' });
        }
    }

    const getVehiclesDetailsReport = async () => {
        Loading.show();
        try {
            const report = await VehiclesService.getVehiclesDetailsReport(criteria);
            const title = t('vehicles_management.list.vehicles_contracts_excel_details_title');
            saveAs(report, `${title}_${moment(new Date()).format('YYYY_MM_DD_HH_mm_ss')}.xlsx`);
            Loading.hide();
        } catch (error) {
            Loading.hide();
            Logger.error(LOGGER_LOG_TYPE.VEHICLES, `Couldn't get vehicles report`, error);
            addToast(t('common.messages.error_load_info'), { appearance: 'error' });
        }
    }
    // const getVehiclesDetailsReport = async () => {
    //     Loading.show();
    //     setShowVehicleReportColumnFilterModal(true);
    //     try {
    //         const report = await VehiclesService.getVehiclesDetailsReport(criteria);
    //         const title = t('vehicles_management.list.vehicles_contracts_excel_details_title');
    //         saveAs(report, `${title}_${moment(new Date()).format('YYYY_MM_DD_HH_mm_ss')}.xlsx`);
    //         Loading.hide();
    //     } catch (error) {
    //         Loading.hide();
    //         Logger.error(LOGGER_LOG_TYPE.VEHICLES, `Couldn't get vehicles report`, error);
    //         addToast(t('common.messages.error_load_info'), { appearance: 'error' });
    //     }
    // }


    const fetchAllForExport = useCallback(async () => {
        const result = await VehiclesService.getList({
            ...criteria,
            page: 1,
            itemsPerPage: MAX_PAGINATION_ITEMS_PER_PAGE,
        });
        return result.items;
    }, [criteria]);

    return (
        <ScreenTitle title={t('vehicles_management.title')}>
            <CompactPageLayout
                title={t('vehicles_management.title') as string}
                contentAreaClassName={styles.contentArea}
                middleContent={<FilterBadgesOverflow items={filterItems} align="right" />}
                headerButtons={
                    <>
                        <Popover
                            contentContainerClassName={styles.filtersPopoverContainer}
                            containerStyle={{ boxShadow: '0 4px 14px rgba(0, 0, 0, 0.1)', backgroundColor: '#fff' }}
                            positions={['bottom', 'left']}
                            align={'end'}
                            onClickOutside={() => updateTotalFilters(filters)}
                            content={setIsPopoverOpen => (
                                <VehiclesManagementFiltersScreen
                                    filters={filters}
                                    hasCountersPolicy={hasCountersPolicy}
                                    onFilter={f => { onChangeFilters(f); setIsPopoverOpen(false); }}
                                    onChange={f => updateTotalFilters(f)}
                                    defaultcostsEndDate={defaultcostsEndDate}
                                />
                            )}
                        >
                            {(isPopoverOpen, setIsPopoverOpen) => (
                                <ScreenHeaderButton icon={FiltersIcon} onClick={() => setIsPopoverOpen(!isPopoverOpen)}>
                                    {filtersTotal > 0 && (
                                        <div className={styles.counterList}>
                                            <div className={styles.counterNumber}>{filtersTotal}</div>
                                        </div>
                                    )}
                                </ScreenHeaderButton>
                            )}
                        </Popover>

                        {hasExportPolicy && (
                            <Dropdown
                                style={{ right: '10px' }}
                                options={
                                    <>
                                        <DropdownItem onClick={() => getExpensesReport(true)}>
                                            {t('export_charges.tooltip_total')}
                                        </DropdownItem>
                                        <DropdownItem onClick={() => getExpensesReport(false)}>
                                            {t('export_charges.tooltip_details')}
                                        </DropdownItem>
                                        <DropdownItem onClick={() => { setReportType('VEHICLE_DETAILS_EXCEL'); setShowReportColumnFilterModal(true); }}>
                                            {t('export_vehicle_contract.title')}
                                        </DropdownItem>
                                        {hasExportListingPolicy && (
                                            <DropdownItem onClick={() => exportListingRef.current?.exportExcel()}>
                                                {t('common.export_listing')}
                                            </DropdownItem>
                                        )}
                                    </>
                                }
                            >
                                <div className={styles.exportButton}>
                                    <FaFileExport size={20} color={colors.primaryDark} />
                                </div>
                            </Dropdown>
                        )}
                    </>
                }
            >
                
                {counters && (
                    <div className={compactPageLayoutStyles.countersSection}>
                        <VatNotice />
                        {renderCounterBoxes()}
                    </div>
                )}

                <div className={compactPageLayoutStyles.listTblWrapper}>
                    <ReportColumnFilterModal
                        companyId={userProfile?.companyId ?? ''}
                        type={reportType}
                        getReport={getReport}
                        isOpen={showReportColumnFilterModal}
                        setIsOpen={setShowReportColumnFilterModal}
                    />
                    {!pageLoaded && (
                        <div style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', minHeight: '20rem' }}>
                            <LoadingSpinner />
                        </div>
                    )}
                    {pageLoaded && (
                        <DataTableWithSidebar
                            key={reRenderSearch}
                            cacheKey="VEHICLESMANAGEMENT_TABLE"
                            columns={tableColumns}
                            rows={vehicles}
                            defaultOrder={order}
                            defaultHiddenColumns={['vehicleSegmentName', 'vehicleLocals']}
                            onRowClick={(row, index, event) => onRowClick(row, index, event)}
                            onOrderChange={handleOrderChange}
                            onHref={row => `/vehicles/details/${row.id}/informations/list/undefined/undefined/undefined/undefined/vehicles-management`}
                            onRowId={row => row.id ?? ''}
                            scrollToRowId={scrollToItemId}
                            infiniteScroll={{
                                isLoading: isLoadingMore,
                                hasMore: getHasMore(vehicles.length, totalItems),
                                onLoadMore: getOnLoadMore(loadMore),
                                hasMorePrevious: getHasMorePrevious(),
                                isLoadingPrevious: isLoadingPrevious,
                                onLoadPrevious: getOnLoadPrevious(loadPrevious),
                            }}
                            exportExcel={{
                                fetchAll: fetchAllForExport,
                                fileName: t('vehicles_management.title') as string,
                            }}
                            exportRef={exportListingRef}
                            hideExportInSidebar={true}
                        />
                    )}
                </div>
            </CompactPageLayout>
            <ReactTooltip />
        </ScreenTitle>
    );
}

export default VehiclesManagementScreen;
